export default __webpack_public_path__ + "static/media/Ice_Bucket.b383387a.svg";